//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import type { IUrlRouterProvider } from 'angular-ui-router';

import {
  NavGroup,
  componentNameToTemplate,
  hasAllFeatures,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  // TODO: PD-318575 - Remove once feature is released
  const isContentSupplyChainEnabled = hasAllFeatures(
    FeatureNames.InsightsContentSupplyChainReporting,
  );

  if (!isContentSupplyChainEnabled) {
    urlRouterProvider.when(
      /\/insights\/content-supply-chain(\/.*)?$/,
      '/insights/summary',
    );
  }
}

export const states = {
  'content-supply-chain': {
    url: '/insights/content-supply-chain?:startDate&:endDate&:ingestionSource&:mediaTypes',
    params: {
      mediaTypes: { array: true, value: [] },
    },
    template: componentNameToTemplate('contentSupplyChainPage'),
    resolve: {
      ...lazyLoadModule(
        'curalate.contentSupplyChain',
        () => import('@insights/ContentSupplyChainApp'),
      ),
    },
    data: {
      title: 'Content Supply Chain',
      navGroup: NavGroup.INSIGHTS,
      // TODO: PD-318575 - Remove once feature is released
      hasAccess: () =>
        hasAllFeatures(FeatureNames.InsightsContentSupplyChainReporting),
    },
  },
};
